import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import PicList from '../../../../components/picList';
import NewsList from '../../../../components/newsList';

class TravelBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { travelTopic, travelTitle, travelList0, travelList1 },
        } = this.props;

        return (
            <div id="travelNewsList" className={styles.travel_box}>
                <Chip id="50077" type="struct" title="旅游酒业栏标题" groupName="旅游酒业栏" content={travelTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75096"
                    type="recommend"
                    title="旅游栏头条"
                    groupName="旅游酒业栏"
                    content={travelTitle}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75097"
                    type="recommend"
                    title="旅游栏新闻列表"
                    groupName="旅游酒业栏"
                    content={travelList0}
                    translate="handleVideoContentData"
                    translateOptions={{ index: 0 }}>
                    <PicList hasEnd />
                </Chip>
                <Chip
                    id="75098"
                    type="recommend"
                    title="酒业栏新闻列表"
                    groupName="旅游酒业栏"
                    content={travelList1}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(TravelBox);
